import React from "react";
import { Mail, Phone, MapPinHouse, Twitter, Linkedin, Facebook, Github, ScanFace } from "lucide-react";
import "../../../styles/contact-card.css";
import { MenuButton } from "../../atoms";

interface ContactCardProps {
  id?: number | string;
  name?: string;
  firstName?: string;
  lastName?: string;
  title: string;
  company: string;
  email: string;
  phone?: string;
  location?: string;
  linkedIn?: string;
  twitter?: string;
  linkedin?: string;
  facebook?: string;
  github?: string;
  onEdit?: () => void;
  onDelete?: () => void;
}

const ContactCard: React.FC<ContactCardProps> = ({
  id,
  name,
  firstName,
  lastName,
  title,
  company,
  email,
  phone,
  location,
  linkedIn,
  twitter,
  linkedin,
  facebook,
  github,
  onEdit,
  onDelete,
}) => {
  const displayName = name || (firstName && lastName ? `${firstName} ${lastName}` : firstName || lastName || 'Unknown');
  const hasLinkedIn = !!linkedIn || !!linkedin;
  const menuItems = [
    {
      label: "Edit",
      onClick: () => {
        if (onEdit) onEdit();
      },
    },
    {
      label: "Delete",
      onClick: () => {
        if (onDelete) onDelete();
      },
      danger: true,
    },
  ];

  return (
    <div className="contact-card">
      <div className="contact-card__header">
        <div className="contact-card__info">
          <div className="contact-card__avatar">
            <ScanFace size={24} />
          </div>
          <div className="contact-card__details">
            <div className="contact-card__name">{displayName}</div>
            <div className="contact-card__title">{title}</div>
            <div className="contact-card__company">{company}</div>
          </div>
        </div>
        <MenuButton menuItems={menuItems} />
      </div>
      <div className="contact-card__divider" />
      <div className="contact-card__contact-info">
        <div className="contact-card__contact-details">
          {email && (
            <a
              className="contact-card__contact-row"
              href={`mailto:${email}`}
              onClick={(e) => e.stopPropagation()}
            >
              <Mail size={14} className="contact-card__contact-icon" />
              <span>{email}</span>
            </a>
          )}
          {phone && (
            <a
              className="contact-card__contact-row"
              href={`tel:${phone}`}
              onClick={(e) => e.stopPropagation()}
            >
              <Phone size={14} className="contact-card__contact-icon" />
              <span>{phone}</span>
            </a>
          )}
          {location && (
            <a
              className="contact-card__contact-row"
              href={`https://www.google.com/maps/search/${encodeURIComponent(location)}`}
              target="_blank"
              rel="nofollow noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              <MapPinHouse size={14} className="contact-card__contact-icon" />
              <span>{location}</span>
            </a>
          )}
        </div>
        <div className="contact-card__socials">
          {twitter && (
            <a
              href={twitter}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-card__social-icon"
              onClick={(e) => e.stopPropagation()}
            >
              <Twitter size={14} />
            </a>
          )}
          {hasLinkedIn && (
            <a
              href={linkedin || linkedIn || ''}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-card__social-icon"
              onClick={(e) => e.stopPropagation()}
            >
              <Linkedin size={14} />
            </a>
          )}
          {facebook && (
            <a
              href={facebook}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-card__social-icon"
              onClick={(e) => e.stopPropagation()}
            >
              <Facebook size={14} />
            </a>
          )}
          {github && (
            <a
              href={github}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-card__social-icon"
              onClick={(e) => e.stopPropagation()}
            >
              <Github size={14} />
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactCard;
